import React, { useState } from "react";
import close from "../../assets/close.svg"

import Accordion from "../../components/Accordion/Accordion";
const FiltersComponent = ({ isWeb, isOpen, toggleDrawer, filters, range, setRange, onapplyFilterclick, clearClick }) => {
    const [defRange, setDefRange] = useState({ min: range?.min, max: range?.max });

    return (
        isWeb ? <div className="EcommerceProduct-left ">
            <div className="EcommerceProduct-left-header">FILTERS {defRange?.min !== defRange?.max && (range?.min != defRange.min || range?.max != defRange.max) && <div className="clear-filter-cont" onClick={() => {
                clearClick()
                setRange({ min: defRange?.min, max: defRange?.max })
            }}>Clear</div>}</div>
            <Accordion items={filters} isSmall layout={"layout1"} range={range} setRange={setRange} onapplyFilterclick={onapplyFilterclick} defRange={defRange} setDefRange={setDefRange} />
        </div> : <div className={`EcommerceFilter-drawer ${isOpen ? 'open' : ''}`}>
            <div className="filter-drawer-header"><div className="header">FILTERS{defRange?.min !== defRange?.max && (range?.min != defRange?.min || range?.max != defRange?.max) && <div className="clear-filter-cont"
                onClick={() => {
                    clearClick()
                    setRange({ min: defRange?.min, max: defRange?.max })

                }}>Clear</div>}
            </div>
                <div className="close-container" onClick={toggleDrawer}><img alt="" src={close} /></div></div>
            <Accordion items={filters} isSmall layout={"layout1"} range={range} setRange={setRange} onapplyFilterclick={onapplyFilterclick} defRange={defRange} setDefRange={setDefRange} toggleDrawer={toggleDrawer} />

        </div>
    )
}
export default FiltersComponent